import { render, staticRenderFns } from "./SettingsFractionalDepositLimit.vue?vue&type=template&id=26616c77"
import script from "./SettingsFractionalDepositLimit.vue?vue&type=script&lang=js"
export * from "./SettingsFractionalDepositLimit.vue?vue&type=script&lang=js"
import style0 from "./SettingsFractionalDepositLimit.vue?vue&type=style&index=0&id=26616c77&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports